import React, { memo } from 'react';
import { FormControl } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Heading from './Heading';
import { Button } from 'react-bootstrap';

interface Props {
  id1: string;
  id2: string;
  fm_id?: number;
  label: string;
  type?: string; // デフォルトはテキスト
  need?: boolean;
  heading1: string;
  heading2: string;
  value1?: string;
  value2?: string;
  placeholder: string;
  handleChange1?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleChange2?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message1?: string;
  message2?: string;
  name?: string;
  suffix?: string;
  help_msg?: string;
  disabled: boolean;
  btn_disabled?: boolean;
  maxlength?: number;
  handleBlur?: VoidFunction;
  handleFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  add_comma?: boolean;
  input_assistance?: string;
  handleClick?: () => void;
}

const TwoText: React.FC<Props> = ({
  id1,
  id2,
  fm_id,
  label,
  type,
  need,
  heading1,
  heading2,
  value1,
  value2,
  placeholder,
  handleChange1,
  handleChange2,
  message1,
  message2,
  name,
  suffix,
  help_msg,
  disabled,
  btn_disabled,
  maxlength,
  handleBlur,
  handleFocus,
  add_comma,
  input_assistance,
  handleClick,
}) => {
  const returnTextFormJsx = () => {
    return type === 'button' ? (
      <>
        <Heading label={heading1} size={'s'} />
        <div className="text-btn_area">
          <FormControl
            className={message1 && 'textarea-error'}
            id={id1}
            data-fm_id={fm_id}
            type={'text'}
            placeholder={placeholder}
            value={value1}
            onChange={handleChange1}
            name={name}
            disabled={disabled}
            onBlur={handleBlur}
            maxLength={maxlength}
          />
          <Button
            size={'sm'}
            variant={'success'}
            className="btn-form"
            onClick={handleClick}
            disabled={btn_disabled}
          >
            選択
          </Button>
        </div>
        <Messages help_msg={help_msg} valid_msg={message1} />
        <div className="mt-3">
          <Heading label={heading2} size={'s'} />
          <div className="text-btn_area">
            <FormControl
              className={message2 && 'textarea-error'}
              id={id2}
              data-fm_id={fm_id}
              type={type}
              placeholder={placeholder}
              value={value2}
              name={name}
              disabled={true}
            />
          </div>
          <Messages valid_msg={message2} />
        </div>
      </>
    ) : (
      <>
        <Heading label={heading1} size={'s'} />
        <FormControl
          className={message1 && 'textarea-error'}
          id={id1}
          data-fm_id={fm_id}
          type={type}
          placeholder={placeholder}
          value={value1}
          onChange={handleChange1}
          name={name}
          disabled={disabled}
          onBlur={handleBlur}
          maxLength={maxlength}
        />
        <Messages help_msg={help_msg} valid_msg={message1} />
        <div className="mt-3">
          <Heading label={heading2} size={'s'} />
          <FormControl
            className={message2 && 'textarea-error'}
            id={id2}
            data-fm_id={fm_id}
            type={type}
            placeholder={placeholder}
            value={value2}
            onChange={handleChange2}
            name={name}
            disabled={disabled}
            onBlur={handleBlur}
            maxLength={maxlength}
          />
          <Messages valid_msg={message2} />
        </div>
      </>
    );
  };

  const returnLabelJsx = () => {
    return type === 'button' ? (
      returnTextFormJsx()
    ) : (
      <>
        <Heading label={heading1} size={'s'} />
        <p>{value1}</p>
        <Messages help_msg={help_msg} />
      </>
    );
  };

  return <RowTemplate label={label} content={disabled ? returnLabelJsx() : returnTextFormJsx()} />;
};

export default memo(TwoText);
